import { Grid } from '@material-ui/core';
import React from 'react';

const RetrackReportHeader = () => {
    return (
        <Grid
            item
            xs={12}
            style={{
                marginBottom: 8,
                padding: '8px 16px',
                background: 'linear-gradient(42deg, rgb(46, 126, 162) 0%, rgb(89, 54, 135) 100%)',
                height: 140,
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <div style={{ fontWeight: 900, fontSize: 40, color: 'white', paddingLeft: 40, alignSelf: 'end' }}>
                ReTrack Report
            </div>
            <div style={{ alignSelf: 'end' }}>
                <img src={'/img/logo_white.png'} style={{ height: 90 }} />
            </div>
        </Grid>
    );
};

export default RetrackReportHeader;
